import React from "react";
import {
  Typography,
  Grid,
  Divider,
  Chip,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Box,
} from "@mui/material";

function PackageDetailsDialog({ packageData }) {
    if (!packageData) {
      return (
        <Box>
          <Typography variant="h6" color="error">
            Package details are not available.
          </Typography>
        </Box>
      );
    }
  
    return (
      <Box>
        {/* Title Section */}
        <Typography variant="h4" gutterBottom>
          {packageData?.listHeading || "N/A"}
        </Typography>
        <Typography variant="subtitle1" color="textSecondary" gutterBottom>
          {packageData?.listSubheading || "N/A"}
        </Typography>
  
        <Divider>
          <Chip label="Package Details" />
        </Divider>
  
        {/* Main Details Section */}
        <Box mt={2}>
          <Typography variant="h6">Duration:</Typography>
          <Typography variant="body1">
            {packageData?.detailHeading || "N/A"}
          </Typography>
          <Typography variant="h6" mt={2}>
            Description:
          </Typography>
          <Typography variant="body1">
            {packageData?.detailDescription_1 || "N/A"}
          </Typography>
        </Box>
  
        <Divider sx={{ my: 2 }} />
  
        {/* Places Included Section */}
        <Typography variant="h6" gutterBottom>
          Places Included:
        </Typography>
        <List>
          {packageData?.placesIncluded?.length ? (
            packageData.placesIncluded.map((place, index) => (
              <ListItem key={index} sx={{ alignItems: "flex-start", mb: 2 }}>
                <ListItemAvatar>
                  {place.placeId.thumbnailImage ? (
                    <Avatar
                      src={place.placeId.thumbnailImage}
                      alt={place.placeId.shortName}
                      sx={{ width: 56, height: 56 }}
                    />
                  ) : (
                    <Avatar>{place.placeId.shortName.charAt(0)}</Avatar>
                  )}
                </ListItemAvatar>
                <ListItemText
                  primary={place.placeId.shortName}
                  secondary={
                    <>
                      <Typography
                        component="span"
                        variant="body2"
                        color="textPrimary"
                        display="block"
                      >
                        {place.placeId.fullName}
                      </Typography>
                      {place.placeId.message || "No additional info available."}
                    </>
                  }
                />
              </ListItem>
            ))
          ) : (
            <Typography variant="body2" color="textSecondary">
              No places included.
            </Typography>
          )}
        </List>
  
        <Divider sx={{ my: 2 }} />
  
        {/* Additional Notes Section */}
        <Typography variant="h6" gutterBottom>
          Additional Notes:
        </Typography>
        {packageData?.additionalNote?.length ? (
          <ul>
            {packageData.additionalNote.map((note, index) => (
              <li key={index}>
                <Typography variant="body2">{note}</Typography>
              </li>
            ))}
          </ul>
        ) : (
          <Typography variant="body2" color="textSecondary">
            No additional notes available.
          </Typography>
        )}
      </Box>
    );
  }
  

export default PackageDetailsDialog;
